import { Monitor, Smartphone, Globe } from 'lucide-react'
import { CollapsibleSection } from './CollapsibleSection'
import { InfoRow } from './InfoRow'
import { formatUrl } from './utils'
import { getBrowserIcon } from './BrowserIcon'

interface DeviceSectionProps {
  browser?: string | null
  os?: string | null
  currentPage: { url: string; title: string | null } | null
  expanded: boolean
  onToggle: () => void
}

function isMobileOs(os: string): boolean {
  return /android|ios|iphone|ipad/i.test(os)
}

export function DeviceSection({ browser, os, currentPage, expanded, onToggle }: DeviceSectionProps) {
  const DeviceIcon = os && isMobileOs(os) ? Smartphone : Monitor

  return (
    <CollapsibleSection title="Visitor device" expanded={expanded} onToggle={onToggle}>
      <div className="space-y-3">
        {os && (
          <InfoRow icon={DeviceIcon} label="Device">
            {os}
          </InfoRow>
        )}
        {browser && (
          <InfoRow icon={getBrowserIcon(browser)} label="Browser">
            {browser}
          </InfoRow>
        )}
        {currentPage && (
          <InfoRow icon={Globe} label="Current page">
            <a href={currentPage.url} target="_blank" rel="noopener noreferrer"
              className="text-primary hover:underline truncate max-w-[200px] inline-block cursor-pointer"
              title={currentPage.url}>
              {currentPage.title || formatUrl(currentPage.url)}
            </a>
          </InfoRow>
        )}
      </div>
    </CollapsibleSection>
  )
}
